export default __webpack_public_path__ + "static/media/ic-math-primary.cf1a68d0.svg";